export default __webpack_public_path__ + "static/media/587969.6a7a7fa0.gif";